
<div class="row column resultCard" [ngClass]="{'noBorderCard': resultRecIndex === 0}">
  <div style="display: flex; margin-left:-50px;"> 

    <div class="vf-form__item vf-form__item--checkbox">
      <input
        type="checkbox"
        name="{{ resultRec.uniprotAccession }}"
        id="{{ resultRec.uniprotAccession }}"
        value="{{ resultRec.uniprotAccession }}"
        class="vf-form__checkbox"
        [checked]="isSelected"
        [disabled]="isLimitReached && !isSelected"
        (change)="notifySelectionChange($event)">
      <label for="{{ resultRec.uniprotAccession }}" class="vf-form__label"></label>
    </div>
  
    <div style="display:flex; align-items: baseline;">
      <a class="vf-link" style="display: inline-block; box-shadow: none;"
        href="/entry/{{resultRec.modelEntityId}}"
       (click)="gaService.eventEmitter(
        'search_click_through',
        'search',
        'click',
        resultRec.uniprotAccession,
        undefined
        )">
        <h3 style="margin-bottom: 4px;" class="resultTitle">{{resultRec.uniprotDescription ? resultRec.uniprotDescription : 'Not named'}}</h3>

      </a>
     
      <app-entry-status [isProteome]="(resultRec.isUniProtReferenceProteome)" [isReviewed]="(resultRec.isUniProtReviewed)"></app-entry-status>
    </div>
  </div>
 
  <div class="subtitleContainer">
    <div class="resultSubtitle"> {{resultRec.modelEntityId}}-v{{resultRec.latestVersion}} </div>
    <div class="dot">•</div> 
    <!-- <div class="resultSubtitle"> {{providerName}} dataset </div> -->
    <div class="resultSubtitle"> Google Deepmind dataset </div>
  </div>
  
<!--  <div class="row resultRow">-->
<!--    <div class="resultLeftCol columns small-4 medium-2">Status</div>-->
<!--    <div class="resultRightCol columns small-8 medium-10">-->
<!--      <app-entry-status [isProteome]="(resultRec.isUniProtReferenceProteome)" [isReviewed]="(resultRec.isUniProtReviewed)"></app-entry-status>-->
<!--    </div>-->
<!--  </div>-->
  <div class="row resultRow">
    <div class="resultLeftCol columns small-4 medium-2">Protein</div>
    <div class="resultRightCol columns small-8 medium-10">{{resultRec.uniprotDescription ? resultRec.uniprotDescription : 'Not named' }}</div>
  </div>

  <div class="row resultRow">
    <div class="resultLeftCol columns small-4 medium-2">Gene</div>
    <div class="resultRightCol columns small-8 medium-10">{{resultRec.gene ? resultRec.gene : 'Not available'}}</div>
  </div>

  <div class="row resultRow">
    <div class="resultLeftCol columns small-4 medium-2">Source organism</div>
    <div class="resultRightCol columns small-8 medium-10" *ngIf="resultRec.organismScientificName">
      {{resultRec.organismScientificName}}
      <a class="vf-link ext" target="_blank"
         href="./search/organismScientificName/{{commonService.escapeValue(resultRec.organismScientificName)}}">search this organism
      </a>
    </div>
    <div class="resultRightCol columns small-8 medium-10" *ngIf="!resultRec.organismScientificName || resultRec.organismScientificName === ''">
      Not available 
    </div>
  </div>

  <div class="row resultRow">
    <div class="resultLeftCol columns small-4 medium-2">UniProt</div>

    <div class="resultRightCol columns small-8 medium-10" *ngIf="resultRec.isUniProt">
      {{resultRec.uniprotAccession}}
      <a target="_blank" href="http://www.uniprot.org/uniprot/{{resultRec.uniprotAccession}}" class="vf-link ext">go to UniProt</a>
    </div>
    <div class="resultRightCol columns small-8 medium-10" *ngIf="!resultRec.isUniProt">
     Not available
    </div>
  </div>

  <div class="row resultRow">
    <div class="resultLeftCol columns small-4 medium-2">Experimental structures</div> 
    <div class="resultRightCol columns small-8 medium-10" *ngIf="resultRec.isUniProt && kbCount && kbCount > 0">{{kbCount}} PDB structure{{kbCount > 1 ? 's' : ''}}
      for {{resultRec.uniprotAccession}}<a target="_blank" href="https://www.ebi.ac.uk/pdbe/pdbe-kb/proteins/{{resultRec.uniprotAccession}}" class="vf-link ext">go to PDBe-KB</a>
    </div>

    <div class="resultRightCol columns small-8 medium-10" *ngIf="resultRec.isUniProt && kbCount === 0">None available in the PDB
    </div>  

    <div class="resultRightCol columns small-8 medium-10" *ngIf="!resultRec.isUniProt">Not available</div>
  </div>

  <div class="row resultRow">
    <div class="resultLeftCol columns small-4 medium-2">Average pLDDT</div>
    <div class="resultRightCol columns small-8 medium-10" *ngIf="resultRec.globalMetricValue">
      {{resultRec.globalMetricValue}} ({{ getPlddtLevel(resultRec.globalMetricValue) }})
    </div>
    <div class="resultRightCol columns small-8 medium-10" *ngIf="!resultRec.globalMetricValue">
      Not available
    </div>
  </div>

  <div class="row resultRow">
    <div class="resultLeftCol columns small-4 medium-2">Sequence length</div>
    <div class="resultRightCol columns small-8 medium-10" *ngIf="resultRec.sequenceStart && resultRec.sequenceEnd">
      {{ (resultRec.sequenceEnd - resultRec.sequenceStart) + 1 }}
    </div>
    <div class="resultRightCol columns small-8 medium-10" *ngIf="!resultRec.sequenceStart || !resultRec.sequenceEnd">
      Not available
    </div>
  </div>

  <app-sequence-card *ngIf="isSequenceSearch  && isBrowser" [isExpandStructure]="false" [hsps]="resultRec.sequenceData"></app-sequence-card>
</div>
